export default "__VITE_ASSET__hxYGIGtK__"